

import RequestAbstract from "../abstract";

export default class WalletUsersKyc extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet/users-kyc";
    }

    async approve(userId, body) {
        return await this.loadWithAuth(this.link + '/approve/' + userId, {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
}

